module.exports = __webpack_public_path__ + "img/curacao.ebb7dd6e.svg";